export class RenamePopup {
    constructor(screenName, renameActionKey) {
        this._container = jQuery("div.rename-account-popup");
        this._oldScreenName = screenName;
        this._renameActionKey = renameActionKey;
        this.initlialiseSelectors();
        this.attachListeners();
    }

    initlialiseSelectors() {
        this._screenNameElement = this._container.find("input[type=text]");
        this._form = this._container.find(".rename-account-form")
        this.host = this._form.data("host")
    }

    hideErrors() {
      let errorTip = jQuery(".rename-account-form .error-tip");
      errorTip.removeClass("show").addClass("hide").hide();
    }

    showError(error, errorElementId) {
        this.hideErrors();
        var errorElement = jQuery(".rename-account-form " + errorElementId);
        errorElement.find("span.message").html(error);
        errorElement.show().siblings( "input" ).addClass("invalid");
        jQuery(".rename-account-form .error-tip").removeClass("hide").addClass("show").show();
    }

    showRenameResponse(response) {
        jQuery(".rename-account-popup .pop-content").hide();
        var confirmationElement = jQuery(".rename-account-popup .confirmation");
        confirmationElement.show().find("p.message").html(response["message"]);
        confirmationElement.on("click", "a.primary-button", function(event) {
          event.preventDefault();
          jQuery(".rename-account-popup").hide();
        })
    }

    renameHandler(event) {
      let that = this;
      event.preventDefault();
      var thisForm = event.target;

      jQuery.ajax({
        url: jQuery(thisForm).attr('action'),
        type: 'post',
        xhrFields: {
            withCredentials: true
        },
        dataType: 'json',
        data: jQuery(thisForm).serialize()
      })
      .done(function(response) {
        jQuery("#signin_user_screen_name").val(jQuery(".rename-account-form #username").val());
        var header =  jQuery(".rename-account-popup .pop-title");
        header.html(header.data("success"));
        that.showRenameResponse(response);
      })
      .fail(function(request) {
        let error = JSON.parse(request.responseText)["error"];
        if(error != undefined) {
          that.showError(error, "#unavailable-username");
        }
        else {
          that.showRenameResponse(JSON.parse(request.responseText));
        }
      });
    }

    validateScreenName() {
      var delay = (function(){
        var timer = 0;
        return function(callback, ms){
          clearTimeout (timer);
          timer = setTimeout(callback, ms);
        };
      })();

      let that = this;
      var screenName = this._screenNameElement.val().trim();
      if(screenName != this._oldScreenName) {
        this._oldScreenName = screenName;
      } else {
        return;
      }
      if (screenName.length <= 2) {
        that.hideErrors();
        jQuery(".rename-account-popup input[type=submit]").removeAttr("enabled");
        jQuery(".rename-account-popup input[type=submit]").attr("disabled", "disabled");
        this._screenNameElement.removeClass("working valid").addClass("invalid");
      } else {
        delay(function() {
          var key = jQuery(".rename-account-form #rename_action_key").val();
          that._screenNameElement.removeClass("valid invalid").addClass("working");
          jQuery.ajax({
              url: that.host + "/screen_name/" + screenName + "/" + key + "/validate",
              method: "post",
              content_type: "json"
          })
          .done(function() {
            that.hideErrors();
            jQuery(".rename-account-popup input[type=submit]").removeAttr("disabled").attr("enabled", "enabled");
            that._screenNameElement.removeClass("invalid working").addClass("valid");
            jQuery(".rename-account-popup input[type=submit]").removeAttr("disabled");
          })
          .fail(function (request, status) {
            jQuery(".rename-account-popup input[type=submit]").removeAttr("enabled");
            that._screenNameElement.removeClass("working valid").addClass("invalid");
            let error = JSON.parse(request.responseText)["error"];
            that.showError(error, "#unavailable-username");
            jQuery(".rename-account-popup input[type=submit]").attr("disabled", "disabled");
          });
        }, 500);
      }
    }

  validateKeyPress(event) {
    let mixCaseRegEx = /^[a-zA-Z0-9]$/g;
    let downcaseRegEx = /^[a-z0-9]$/g;
    let regEx = this._screenNameElement.val().length > 1 ? downcaseRegEx : mixCaseRegEx
    if (!regEx.test(event.key)) {
        event.preventDefault();
    }
}


    attachListeners() {
      let that = this;
      this._screenNameElement.on("keypress", function (event) {
            that.validateKeyPress(event);
        });
      this._screenNameElement.on("keyup", function (event) {
            that.validateScreenName();
        });
      this._form.on('submit', function (event) {
            event.stopImmediatePropagation();
            that.renameHandler(event);
        });
    }

    show() {
        this.resetForm();
        this._container.show();
        this._container.find(".popup").show();
    }

  resetForm() {
        var header =  jQuery(".rename-account-popup .pop-title");
        header.html(header.data('initial'));
        this._screenNameElement.removeClass('valid');
        jQuery(".pop-content", this._popup).show();
        jQuery(".confirmation", this._popup).hide();
        jQuery("input[type=submit]", this._popup).removeAttr("enabled");
        jQuery(".rename-account-popup input[type=submit]").attr("disabled", "disabled");
        jQuery('input[type=text]', this._popup).val("");
        jQuery(".input-wrap input[type=text]").trigger( "input" );
    }
}